<script setup>
import Grid from "../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import {onMounted, ref} from "vue";
import corporatesService from "@/services/corporates.service";
import CorporateEdit from "@/components/corporates/CorporateEdit.vue";
import CorporateSync from "@/components/corporates/CorporateSync.vue";

const {items, gridParams, gridMethods} = useGrid(corporatesService.getList);

const columns = [
    {
        label: 'ID',
        name: 'id',
        filter: 'text',
    },
    {
        label: 'Name',
        name: 'name',
        filter: 'text',
    },
    {
        label: 'Domain',
        name: 'url_domain',
        filter: 'text',
        component: 'Link',
    },
    {
        label: 'Enterprise ID',
        name: 'enterprise_id',
        filter: 'text',
    },
    {
        label: 'Corp Startup ID',
        name: 'corp_startup_id',
        filter: 'text',
    },
    {
        label: 'Merged To ID',
        name: 'merged_to_id',
        filter: 'text',
    },
    {
        label: 'Created At',
        name: 'created_at',
        component: 'Date',
        sortable: true,
    },
    {
        label: 'Partnerships',
        name: 'partnerships_count',
        component: 'Link',
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

const editCorporate = ref(null);
const syncCorporate = ref(null);

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function gridAction(params) {
    if (params.action === 'edit') {
        editCorporate.value.open(params.rowId);
    } else if (params.action === 'delete') {
        remove(params.rowId);
    } else if (params.action === 'sync') {
        syncCorporate.value.open(params.rowId);
    }
}

async function remove(id) {
    if (confirm("Delete corporate?")) {
        await corporatesService.delete(id);
        gridMethods.updateList();
    }
}
</script>

<template>
    <div>
        <div class="topbar pl-sm-5">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header>
                        <button class="button w-100 w-sm-auto" @click="editCorporate.open()">Add Corporate</button>
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    has-filters
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                    @changeFilters="gridMethods.setFilters"
                    @changeSort="gridMethods.changeSort"
                    @action="gridAction"
                />
            </div>
        </div>

        <CorporateEdit
            ref="editCorporate"
            @saved="gridMethods.updateList"
        />

        <CorporateSync
            ref="syncCorporate"
            @synced="gridMethods.updateList"
        />
    </div>
</template>

<style scoped>

</style>
